import {combineReducers} from 'redux';

import {amazonV2} from './amazonV2/amazonV2';
import {applePay} from './applePay/applePay';
import {creditCard} from './creditCard/creditCard';
import {oneStep} from './oneStep/oneStep';
import {payerInfo} from './payerInfo/payerInfo';
import {paymentMethods} from './paymentMethods/paymentMethods';
import {paymentMethodSave} from './paymentMethodSave/paymentMethodSave';
import {paypal} from './paypal/paypal';
import {savePaymentData} from './savePaymentData/savePaymentData';
import {selectedMethod} from './selectedMethod/selectedMethod';

export const paymentStep = combineReducers({
    amazonV2,
    applePay,
    creditCard,
    oneStep,
    payerInfo,
    paymentMethods,
    paymentMethodSave,
    paypal,
    savePaymentData,
    selectedMethod,
});
